module.exports = __webpack_public_path__ + "media/15.673ab1eb.mp3";